import { CommonService } from './../../../../services/utils/common.service';
import { PermissionConfiguration, ApiMethods } from './../../../../models/permission.model';
import { PermsService } from './../../../../services/utils/perms.service';
import { KontableComponent } from './../../../../modules/UIKit/components/kontable/kontable.component';
import { LoyaltyReservationsService } from './../../../../services/loyalty/loyalty-reservations.service';
import { LoyaltyPrintTemplateService } from './../../../../services/loyalty/loyalty-print-template.service';
import { TranslateService } from '@ngx-translate/core';
import { MessageService, ConfirmationService } from 'primeng/primeng';
import { LoyaltyGiftReservationService } from './../../../../services/loyalty/loyalty-gift-reservation.service';
import { CalendarTranslateService } from './../../../../modules/UIKit/services/calendarTranslate.service';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';

@Component({
  selector: 'app-loyalty-active-reservations',
  templateUrl: './loyalty-active-reservations.component.html',
  styleUrls: ['./loyalty-active-reservations.component.css']
})
export class LoyaltyActiveReservationsComponent implements OnInit {
  msgEmailSend: string;
  cancelReservationErrorMsg: string;
  cancelReservationConfirmMsg: string;
  cancelReservationOkMsg: string;
  pickupOkMsg: string;
  pickUpMessage: string;

  customerPermissions = {
    customerMg: false
  }

  resCustomerPermissions: any;
  reqDownloadInvoicesPermission: PermissionConfiguration;
  reqUploadInvoicesPermission: PermissionConfiguration;

  row: any;

  dateFilter = KontableComponent.DateFilter;

  modalFatturePremi = {
    codice_cliente: "",
    card_no: "",
    name: "",
    surname: "",
    num_reservation: "",
    customerId: ""
  }

  show = {
    modalFatturePremi: false
  }

  @Input() reservations: any[];
  @Input() customerId: string;
  @Input() cardNumber: string;
  @Input() prefixQrCode: string;

  @Output() onShowDetails: EventEmitter<any> = new EventEmitter();
  @Output() onGetReservations: EventEmitter<any> = new EventEmitter();
  @Output() onClosePopup: EventEmitter<any> = new EventEmitter();
  @Output() onCredit: EventEmitter<number> = new EventEmitter();

  @ViewChild('activeReservationTable') activeReservationTable: any;

  constructor(
    public calendarTranslateService: CalendarTranslateService,
    private giftService: LoyaltyGiftReservationService,
    private messageService: MessageService,
    private translateService: TranslateService,
    public printer: LoyaltyPrintTemplateService,
    private reservationService: LoyaltyReservationsService,
    private confirmationService: ConfirmationService,
    private srvPermission: PermsService,
    private commonService: CommonService
  ) { }

  ngOnInit() {


    this.resCustomerPermissions = [];

    this.reqDownloadInvoicesPermission = {
      ms_base: 'koncentro-customers',
      operation: 'customer-invoices-gift-download',
      method: ApiMethods.GET
    };

    this.reqUploadInvoicesPermission = {
      ms_base: 'koncentro-customers',
      operation: 'customer-invoices-gift-upload',
      method: ApiMethods.POST
    };

    this.translateService.get([
      'reservations.cancelReservationError',
      'reservations.cancelReservationConfirm',
      'reservations.cancelReservationOk',
      'reservations.pickupOk',
      'reservations.emailSended'
    ]).subscribe(res => {
      this.cancelReservationErrorMsg = res['reservations.cancelReservationError'];
      this.cancelReservationConfirmMsg = res['reservations.cancelReservationConfirm'];
      this.cancelReservationOkMsg = res['reservations.cancelReservationOk'];
      this.pickupOkMsg = res['reservations.pickupOk'];
      this.msgEmailSend = res['reservations.emailSended'];
    });

    this.srvPermission.getCustomerPermission().subscribe(res=>{

      if(res){

        this.resCustomerPermissions = res;

        let customerMgCheck: PermissionConfiguration = {
          ms_base: 'koncentro-customers',
          operation: 'customer-mg',
          method: ApiMethods.POST
        };

        this.customerPermissions.customerMg = this.srvPermission.checkPermission(res,customerMgCheck);
      }
    })


  }

  /**
   * Invia Email al cliente
   */
  sendEmail(reservation: any) {
    if (
      reservation.status.toUpperCase() === 'PRONTO' &&
      (
        reservation.delivery_type_id === '0001' ||
        (reservation.delivery_type_id === '0003'&& reservation.flg_pickup_store === 'S')
      )
    ) {

        this.giftService.sendConfirmReservationEmail(null, reservation.num_reservation, reservation.id, null, reservation.gift_code).subscribe(
          () => this.messageService.add({severity: 'success', summary: 'Success', detail: this.msgEmailSend })
        );
    } else {
      this.giftService.sendConfirmReservationEmail(reservation.id).subscribe(
        () => this.messageService.add({severity: 'success', summary: 'Success', detail: this.msgEmailSend })
      );
    }
  }

  /**
   * Visualizzazione del pop-up di scelta di stampa
   * se il record è un premio fisico parte la stampa digitale
   * @param $event
   */
  showPrintPopUp($event){
    if($event.status.toUpperCase() === "PRONTO"){
      this.printer.generateReportArticoloPronto($event, this.prefixQrCode);
    }else{
      this.row = $event;
      this.generateReportSpecific($event);
    }
  }

  /**
   * Generazione del report specifico di un item
   * @param $event
   */
  generateReportSpecific($event){
    var cardNo: string = $event.card_no;
    if(cardNo.length == 12){

      $event.card_no = this.commonService.getCardWithCheckdigit(cardNo);
      console.log($event.card_no);
      this.printer.generateReportPagamentoSpecific($event, this.prefixQrCode);      

      /*
      this.reservationService.getCardCheckDigit($event.card_no).subscribe(res => {
        $event.card_no = res
        console.log(res);
        this.printer.generateReportPagamentoSpecific($event, this.prefixQrCode);
      });
      */
     
      this.closePopup();
    }else{
      this.printer.generateReportPagamentoSpecific($event, this.prefixQrCode);
      console.log('$$$$$$',$event.card_no);
      this.closePopup();
    }
  }

  /**
   * Ritiro dell'articolo da parte del cliente, cambio stato articolo in RITIRATO
   */
  pickupGift(reservationId: number){
    this.reservationService.changeReservationItemStatus(reservationId, 'RITIRATO').subscribe(() => {
      this.onGetReservations.emit();
      this.confirmationService.confirm({
        message: this.pickupOkMsg,
        acceptLabel: 'Ok',
        rejectVisible: false
      });
    });
  }

  /**
   * Apre dialog di conferma annullamento prenotazione
   */
  confirmCancelReservation(reservation) {
    this.confirmationService.confirm({
      message: this.cancelReservationConfirmMsg,
      acceptLabel: 'Ok',
      accept: () => this.cancelReservation(reservation),
      rejectVisible: true
    });
  }

  /**
   * Annulla la prenotazione
   */
  cancelReservation(reservation) {
    this.giftService.getSourceSystemFromStore(reservation.store_id).subscribe(res => {
      const creditData = {
        acm: sessionStorage.getItem('acmCode'),
        amnt: reservation.points,
        card: this.cardNumber,
        channel: res[0].code,
        // partner: 'KONCENTRO',
        // rsn: '200',
        //store: reservation.store_host_code,
        store: reservation.store_host_code.split(' - ')[0],
        transactionDate: new Date(),
        transactionId: reservation.id,
        itm: reservation.barcode
      };
      this.giftService.credit(creditData, reservation.catalog_id).subscribe(() => {
        this.reservationService.changeReservationItemStatus(reservation.id, 'ANNULLATO').subscribe(
          () => {
            this.onCredit.emit(reservation.points);
            this.onGetReservations.emit();
            this.giftService.sendRemoveReservationEmail(reservation.id).subscribe();
            this.confirmationService.confirm({
              message: this.cancelReservationOkMsg,
              acceptLabel: 'Ok',
              rejectVisible: false
            });
          },
          err => {
            console.error(err);
            this.confirmationService.confirm({
              message: this.cancelReservationErrorMsg,
              acceptLabel: 'Ok',
              accept: () => this.debit(reservation),
              rejectVisible: false
            });
          }
        );
      });
      //this.printer.generateReportRimborso(reservation);
    });
  }

  debit(reservation) {
    this.giftService.getSourceSystemFromStore(reservation.store_id).subscribe(res => {
      const debitData = {
        acm: sessionStorage.getItem('acmCode'),
        amnt: reservation.points,
        card: this.cardNumber,
        channel: res[0].code,
        // partner: 'KONCENTRO',
        // rsn: '406',
        store: reservation.store_host_code,
        transactionDate: new Date(),
        transactionId: reservation.id,
        itm: reservation.barcode
      };
      this.giftService.debit(debitData, reservation.catalog_id).subscribe();
    })
  }

  /**
   * Override del metodo che aggiunge il bottone 'Close'
   */
  addButton(){
    this.printer.addCloseButton = () => {
      const userButton = this.printer.viewerPagamentoCassa.jsObject.SmallButton('userButton', 'Close', 'emptyImage');
      const self = this;
      userButton.action = function () {
      self.printer.showMeReport = false;
        $('body').css('overflow', 'auto');
      }
      const toolbarTable = this.printer.viewerPagamentoCassa.jsObject.controls.toolbar.firstChild.firstChild;
      const buttonsTable = toolbarTable.rows[0].lastChild.lastChild;
      const userButtonCell = buttonsTable.rows[0].insertCell(0);
      userButtonCell.className = 'stiJsViewerClearAllStyles';
      userButtonCell.appendChild(userButton);
    };
  }
  /**
   * Apertura modal download e upload Fatture
   */
  onClickFatturePremi(reservation){
    this.modalFatturePremi.codice_cliente = reservation.codice_cliente;
    this.modalFatturePremi.card_no = reservation.card_no;
    this.modalFatturePremi.name = reservation.cust_name;
    this.modalFatturePremi.surname = reservation.cust_surname;
    this.modalFatturePremi.num_reservation = reservation.num_reservation;
    this.modalFatturePremi.customerId = this.customerId;
    this.show.modalFatturePremi = true;
  }
  /**
   * Chiusura pop-up
   */
  closePopup(){
    this.onClosePopup.emit();
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-reservations/loyalty-active-reservations/loyalty-active-reservations.component.ts